export default __webpack_public_path__ + "static/media/win_popup.1f88e269.png";